// Français.
export default {
    'canvas.title': 'Contenu de la page',
    'canvas.loading': 'Chargement de l’éditeur…',
    'empty.title': 'Commencez votre page',
    'empty.text': 'Glissez ici un bloc ou une section toute prête, ou cliquez dessus pour l’ajouter.',
    'empty.sections': 'Voir les sections',
    'empty.blocks': 'Ajouter un bloc',

    'panel.insert': 'Ajouter',
    'panel.settings': 'Réglages',
    'panel.content': 'Contenu',
    'panel.layout': 'Mise en page',
    'panel.style': 'Style',
    'panel.visibility': 'Visibilité',
    'panel.advanced': 'Avancé',
    'tab.blocks': 'Blocs',
    'tab.sections': 'Sections',
    'tab.layers': 'Calques',
    'category.layout': 'Mise en page',
    'category.basic': 'Essentiels',
    'category.media': 'Médias',
    'category.components': 'Composants',
    'category.advanced': 'Avancé',
    'palette.hint': 'Glissez dans la page, ou cliquez pour ajouter',
    'palette.none': 'Aucun bloc ne correspond à votre recherche.',
    'sections.intro': 'Glissez une section dans la page, ou cliquez pour l’ajouter. Tout reste modifiable.',
    'layers.empty': 'La page est vide.',
    'inspector.empty': 'Sélectionnez un bloc de la page pour modifier son contenu et son style.',
    'inspector.path': 'Position dans la page',

    'device.label': 'Taille de l’aperçu',
    'device.desktop': 'Ordinateur',
    'device.tablet': 'Tablette',
    'device.mobile': 'Téléphone',

    'action.undo': 'Annuler',
    'action.redo': 'Rétablir',
    'action.guides': 'Afficher les contours des blocs',
    'action.preview': 'Aperçu',
    'action.code': 'Modifier le code',
    'action.copyCode': 'Copier le code',
    'action.fullscreen': 'Plein écran',
    'action.selectParent': 'Sélectionner le bloc parent',
    'action.move': 'Glisser pour déplacer',
    'action.moveUp': 'Monter',
    'action.moveDown': 'Descendre',
    'action.duplicate': 'Dupliquer',
    'action.remove': 'Supprimer',
    'action.close': 'Fermer',
    'action.apply': 'Appliquer',
    'action.cancel': 'Annuler',
    'action.clear': 'Effacer',
    'action.search': 'Rechercher',
    'action.searchBlocks': 'Rechercher un bloc…',
    'action.addColumn': 'Ajouter une colonne',
    'action.equalize': 'Largeurs égales',
    'action.addButton': 'Ajouter un bouton',
    'action.addItem': 'Ajouter un élément',
    'action.resizeColumns': 'Glisser pour redimensionner les colonnes',

    'category.saved': 'Enregistrés',
    'action.saveBlock': 'Enregistrer comme bloc réutilisable',
    'action.save': 'Enregistrer',
    'action.restore': 'Restaurer',
    'saved.name': 'Nom du bloc',
    'saved.help': 'Le bloc et tout ce qu’il contient seront proposés dans Blocs › Enregistrés, pour cette page et les suivantes.',
    'saved.done': 'Bloc enregistré : retrouvez-le dans Blocs › Enregistrés.',
    'saved.remove': 'Retirer ce bloc enregistré',
    'notice.draftFound': 'Des modifications du {date} n’ont pas été enregistrées.',
    'error.storage': 'Le navigateur a refusé de garder ce bloc (stockage plein ou désactivé).',
    'shortcut.undo': 'annuler',
    'shortcut.duplicate': 'dupliquer',
    'shortcut.move': 'monter ou descendre',
    'shortcut.remove': 'supprimer',
    'shortcut.parent': 'sélectionner le parent',
    'shortcut.edit': 'modifier le texte',

    'block.container': 'Conteneur',
    'block.containerFluid': 'Pleine largeur',
    'block.box': 'Boîte',
    'block.row': 'Rangée',
    'block.col': 'Colonne',
    'block.heading': 'Titre',
    'block.text': 'Texte',
    'block.quote': 'Citation',
    'block.list': 'Liste',
    'block.table': 'Tableau',
    'block.button': 'Bouton',
    'block.separator': 'Séparateur',
    'block.spacer': 'Espace',
    'block.icon': 'Icône',
    'block.html': 'HTML',
    'block.image': 'Image',
    'block.video': 'Vidéo',
    'block.embed': 'Page intégrée',
    'block.map': 'Carte',
    'block.card': 'Carte d’article',
    'block.accordion': 'Accordéon',
    'preset.cols1': '1 colonne',
    'preset.cols2': '2 colonnes',
    'preset.cols3': '3 colonnes',
    'preset.cols4': '4 colonnes',
    'preset.cols84': '2/3 + 1/3',
    'preset.cols48': '1/3 + 2/3',
    'preset.cols363': '1/4 + 1/2 + 1/4',
    'preset.cols6': '6 colonnes',

    'placeholder.heading': 'Votre titre',
    'placeholder.text': 'Écrivez votre texte ici. Sélectionnez des mots pour les mettre en gras, en italique ou en lien.',
    'placeholder.quote': 'Une belle citation, courte et mémorable.',
    'placeholder.author': 'Nom de l’auteur',
    'placeholder.item': 'Élément',
    'placeholder.column': 'Colonne',
    'placeholder.button': 'Cliquez ici',
    'placeholder.readMore': 'Lire la suite',
    'placeholder.caption': 'Légende de l’image',
    'placeholder.cardTitle': 'Titre de la carte',
    'placeholder.cardText': 'Une courte description qui donne envie d’en savoir plus.',
    'placeholder.question': 'Question',
    'placeholder.answer': 'La réponse, en quelques phrases claires.',
    'placeholder.html': 'Votre code HTML',
    'placeholder.address': 'Tour Eiffel, Paris',

    'field.width': 'Largeur',
    'field.tag': 'Balise HTML',
    'field.gutters': 'Espace entre les colonnes',
    'field.justify': 'Alignement horizontal',
    'field.alignItems': 'Alignement vertical',
    'field.alignSelf': 'Alignement vertical dans la rangée',
    'field.columnWidth': 'Largeur selon l’écran',
    'field.level': 'Niveau',
    'field.size': 'Taille',
    'field.thickness': 'Épaisseur',
    'field.opacity': 'Opacité',
    'field.height': 'Hauteur',
    'field.icon': 'Icône',
    'field.filled': 'Pleine',
    'field.image': 'Image',
    'field.alt': 'Texte alternatif',
    'field.link': 'Lien',
    'field.newTab': 'Ouvrir dans un nouvel onglet',
    'field.caption': 'Légende',
    'field.align': 'Alignement',
    'field.ratio': 'Proportions',
    'field.corners': 'Coins',
    'field.shadow': 'Ombre',
    'field.videoUrl': 'Vidéo',
    'field.controls': 'Afficher les commandes',
    'field.autoplay': 'Lecture automatique (sans le son)',
    'field.loop': 'En boucle',
    'field.muted': 'Sans le son',
    'field.url': 'Adresse (URL)',
    'field.address': 'Adresse',
    'field.zoom': 'Zoom',
    'field.showImage': 'Afficher une image',
    'field.titleLevel': 'Niveau du titre',
    'field.showButton': 'Afficher un bouton',
    'field.firstOpen': 'Premier élément ouvert',
    'field.items': 'Éléments',
    'field.question': 'Question',
    'field.text': 'Texte',
    'field.style': 'Style',
    'field.code': 'Code HTML',
    'field.textAlign': 'Alignement du texte',
    'field.spacing': 'Espacements',
    'field.margin': 'Marge extérieure',
    'field.padding': 'Marge intérieure',
    'field.background': 'Fond',
    'field.backgroundImage': 'Image de fond',
    'field.textColor': 'Couleur du texte',
    'field.border': 'Bordure',
    'field.showOn': 'Afficher sur',
    'field.id': 'Ancre (ID)',
    'field.classes': 'Classes CSS',
    'field.inlineStyle': 'Style en ligne',
    'side.t': 'en haut',
    'side.b': 'en bas',
    'side.s': 'à gauche',
    'side.e': 'à droite',

    'help.alt': 'Décrit l’image aux personnes qui ne la voient pas et aux moteurs de recherche.',
    'help.video': 'Un lien YouTube ou Vimeo, ou l’adresse d’un fichier MP4.',
    'help.embed': 'L’adresse d’une page qui accepte d’être intégrée (un formulaire, un agenda…).',
    'help.columnWidth': 'Le téléphone d’abord : une taille vide reprend celle de l’écran plus petit, affichée en gris.',
    'help.visibility': 'Décochez une taille pour masquer le bloc sur ces écrans.',
    'help.id': 'Permet à un lien de pointer vers ce bloc : #ancre.',
    'help.classes': 'Classes de votre thème ou de Bootstrap, séparées par des espaces.',
    'help.accordion': 'Cliquez sur une question ou une réponse dans la page pour modifier son texte.',
    'help.html': 'Les scripts et les attributs d’événement sont retirés par sécurité.',

    'option.default': 'Par défaut',
    'option.none': 'Aucun',
    'option.auto': 'Auto',
    'option.fill': 'Remplir',
    'option.inherit': 'Hériter',
    'option.custom': 'Couleur personnalisée',
    'option.boxed': 'Centré',
    'option.fullWidth': 'Pleine largeur',
    'option.start': 'Gauche',
    'option.center': 'Centre',
    'option.end': 'Droite',
    'option.between': 'Réparti',
    'option.top': 'Haut',
    'option.middle': 'Milieu',
    'option.bottom': 'Bas',
    'option.wrapLeft': 'À gauche, texte autour',
    'option.wrapRight': 'À droite, texte autour',
    'option.original': 'D’origine',
    'option.square': 'Droits',
    'option.rounded': 'Arrondis',
    'option.pill': 'Pilule',
    'option.circle': 'Cercle',
    'option.small': 'Petite',
    'option.medium': 'Moyenne',
    'option.large': 'Grande',
    'button.primary': 'Principal',
    'button.outline-primary': 'Principal, contour',
    'button.secondary': 'Secondaire',
    'button.outline-secondary': 'Secondaire, contour',
    'button.success': 'Succès',
    'button.outline-success': 'Succès, contour',
    'button.danger': 'Danger',
    'button.outline-danger': 'Danger, contour',
    'button.warning': 'Avertissement',
    'button.outline-warning': 'Avertissement, contour',
    'button.info': 'Info',
    'button.outline-info': 'Info, contour',
    'button.light': 'Clair',
    'button.outline-light': 'Clair, contour',
    'button.dark': 'Sombre',
    'button.outline-dark': 'Sombre, contour',
    'button.link': 'Lien',

    'rte.toolbar': 'Mise en forme du texte',
    'rte.format': 'Style de paragraphe',
    'rte.paragraph': 'Paragraphe',
    'rte.lead': 'Chapeau',
    'rte.small': 'Petit texte',
    'rte.table': 'Tableau…',
    'rte.rowAbove': 'Insérer une ligne au-dessus',
    'rte.rowBelow': 'Insérer une ligne en dessous',
    'rte.colLeft': 'Insérer une colonne à gauche',
    'rte.colRight': 'Insérer une colonne à droite',
    'rte.deleteRow': 'Supprimer la ligne',
    'rte.deleteCol': 'Supprimer la colonne',
    'rte.deleteTable': 'Supprimer le tableau',
    'rte.heading': 'Titre {n}',
    'rte.quote': 'Citation',
    'rte.code': 'Code',
    'rte.bold': 'Gras (Ctrl+B)',
    'rte.italic': 'Italique (Ctrl+I)',
    'rte.underline': 'Souligné (Ctrl+U)',
    'rte.strike': 'Barré',
    'rte.link': 'Lien (Ctrl+K)',
    'rte.unlink': 'Retirer le lien',
    'rte.bulletList': 'Liste à puces',
    'rte.numberedList': 'Liste numérotée',
    'rte.alignLeft': 'Aligner à gauche',
    'rte.alignCenter': 'Centrer',
    'rte.alignRight': 'Aligner à droite',
    'rte.justify': 'Justifier',
    'rte.clear': 'Effacer la mise en forme',

    'media.upload': 'Envoyer',
    'media.library': 'Choisir',
    'media.urlOnly': 'Collez l’adresse du fichier. Envoyer des fichiers de l’ordinateur demande une adresse d’envoi (option uploadUrl).',
    'media.embedded': 'Image enregistrée dans la page',

    'code.title': 'Code HTML de la page',
    'code.help': 'Modifiez le code puis appliquez : PageFlow retrouve ses blocs. Les scripts sont retirés.',

    'notice.copied': 'Code copié dans le presse-papiers',
    'notice.noGrid': 'Les styles du site ne se sont pas chargés dans l’éditeur : une grille simple les remplace en attendant. Vérifiez l’option canvasStyles.',
    'notice.codeApplied': 'Code appliqué',
    'notice.cannotInsert': 'Ce bloc ne peut pas aller ici. Sélectionnez d’abord une colonne ou un conteneur.',
    'error.copy': 'Le code n’a pas pu être copié. Sélectionnez-le dans la vue du code.',
    'error.fileType': 'Ce type de fichier n’est pas accepté ici.',
    'error.fileSize': 'Ce fichier est trop lourd ({size} Mo au plus).',
    'error.upload': 'Le fichier n’a pas pu être envoyé.',
    'error.noUpload': 'Aucune adresse d’envoi n’est réglée : les fichiers de l’ordinateur ne peuvent pas être envoyés. Collez plutôt l’adresse du fichier (développeurs : option uploadUrl, gestionnaire PHP fourni).',

    'sec.heroSplit': 'Accroche avec image',
    'sec.heroSplitDesc': 'Titre, texte et boutons à côté d’une photo.',
    'sec.heroCenter': 'Accroche centrée',
    'sec.heroCenterDesc': 'Un grand message centré sur un bandeau clair.',
    'sec.features': 'Points forts',
    'sec.featuresDesc': 'Trois points forts avec des icônes.',
    'sec.imageText': 'Image et texte',
    'sec.imageTextDesc': 'Une photo à côté d’un texte et d’une liste.',
    'sec.cta': 'Appel à l’action',
    'sec.ctaDesc': 'Un bandeau coloré avec un bouton clair.',
    'sec.cards': 'Cartes',
    'sec.cardsDesc': 'Trois articles, produits ou services.',
    'sec.testimonials': 'Témoignages',
    'sec.testimonialsDesc': 'Ce que vos clients disent de vous.',
    'sec.pricing': 'Tarifs',
    'sec.pricingDesc': 'Trois formules côte à côte.',
    'sec.faq': 'FAQ',
    'sec.faqDesc': 'Questions et réponses qui s’ouvrent d’un clic.',
    'sec.stats': 'Chiffres clés',
    'sec.statsDesc': 'Quatre chiffres qui inspirent confiance.',
    'sec.team': 'Équipe',
    'sec.teamDesc': 'Portraits avec noms et fonctions.',
    'sec.contact': 'Contact',
    'sec.contactDesc': 'Adresse, téléphone et e-mail à côté d’une carte.',
    'sec.gallery': 'Galerie',
    'sec.galleryDesc': 'Six photos en grille.',
    'sec.heroTitle': 'Créez de belles pages en quelques minutes',
    'sec.heroText': 'Glissez, déposez, écrivez : votre page est prête, adaptée aux téléphones et propre, sans une ligne de code.',
    'sec.getStarted': 'Commencer',
    'sec.learnMore': 'En savoir plus',
    'sec.contactUs': 'Nous contacter',
    'sec.imageAlt': 'Photo',
    'sec.centerTitle': 'Tout ce qu’il faut, rien de trop',
    'sec.centerText': 'Une promesse simple qui dit à vos visiteurs qu’ils sont au bon endroit.',
    'sec.featuresTitle': 'Pourquoi nous choisir',
    'sec.featuresText': 'Trois bonnes raisons, en quelques mots.',
    'sec.feature1': 'Rapide',
    'sec.feature2': 'Fiable',
    'sec.feature3': 'Pensé pour les téléphones',
    'sec.featureText': 'Décrivez ce point fort en une ou deux phrases qui parlent à vos visiteurs.',
    'sec.imageTextTitle': 'Racontez votre histoire',
    'sec.imageTextText': 'Expliquez ce que vous faites et comment vous aidez, avec les mots de vos clients.',
    'sec.point1': 'Un premier avantage',
    'sec.point2': 'Un deuxième avantage',
    'sec.point3': 'Un troisième avantage',
    'sec.ctaTitle': 'Prêt à commencer ?',
    'sec.ctaText': 'Rejoignez ceux qui nous font déjà confiance. Cela ne prend qu’une minute.',
    'sec.cardsTitle': 'Dernières nouvelles',
    'sec.cardTitle': 'Un titre de carte',
    'sec.cardText': 'Un court résumé qui donne envie de lire la suite.',
    'sec.readMore': 'Lire la suite',
    'sec.testimonialsTitle': 'Ce que disent nos clients',
    'sec.quote1': 'Simple, rapide et beau. Nous avons refait tout notre site en un week-end.',
    'sec.quote2': 'Le support a répondu dans l’heure. Je les recommande sans hésiter.',
    'sec.quote3': 'Nos visiteurs restent plus longtemps et nous contactent plus souvent depuis les nouvelles pages.',
    'sec.name1': 'Emma Laurent',
    'sec.name2': 'Lucas Martin',
    'sec.name3': 'Sofia Rossi',
    'sec.role1': 'Fondatrice, Studio Nord',
    'sec.role2': 'Gérant, Port Bleu',
    'sec.role3': 'Directrice, Atelier Verde',
    'sec.pricingTitle': 'Des tarifs simples',
    'sec.pricingText': 'Sans frais cachés. Changez ou arrêtez quand vous voulez.',
    'sec.plan1': 'Essentiel',
    'sec.plan2': 'Professionnel',
    'sec.plan3': 'Entreprise',
    'sec.month': 'mois',
    'sec.benefit1': 'Un premier avantage',
    'sec.benefit2': 'Un deuxième avantage',
    'sec.benefit3': 'Un troisième avantage',
    'sec.choose': 'Choisir cette formule',
    'sec.faqTitle': 'Questions fréquentes',
    'sec.question1': 'Comment commencer ?',
    'sec.answer1': 'Choisissez une formule, créez votre compte et suivez le guide : quelques minutes suffisent.',
    'sec.question2': 'Puis-je changer de formule plus tard ?',
    'sec.answer2': 'Oui, à tout moment. La différence est calculée pour vous.',
    'sec.question3': 'Proposez-vous de l’aide ?',
    'sec.answer3': 'Notre équipe répond par e-mail chaque jour ouvré.',
    'sec.question4': 'Mes données sont-elles en sécurité ?',
    'sec.answer4': 'Vos données sont conservées en sécurité et jamais partagées.',
    'sec.stat1': 'clients satisfaits',
    'sec.stat2': 'de satisfaction',
    'sec.stat3': 'assistance',
    'sec.stat4': 'pays',
    'sec.teamTitle': 'L’équipe',
    'sec.member': 'Membre de l’équipe',
    'sec.jobTitle': 'Fonction',
    'sec.contactTitle': 'Contactez-nous',
    'sec.contactText': 'Nous serons ravis de vous lire. Écrivez-nous ou venez nous voir.',
    'sec.addressLabel': 'Adresse',
    'sec.address': '5 avenue Anatole France, 75007 Paris',
    'sec.phoneLabel': 'Téléphone',
    'sec.emailLabel': 'E-mail',
    'sec.galleryTitle': 'Galerie',
};
